export default __webpack_public_path__ + "static/media/lateral-left.5d2b8e5c.png";